import { render, staticRenderFns } from "./ChatCallOverlay.vue?vue&type=template&id=368e510f"
import script from "./ChatCallOverlay.vue?vue&type=script&lang=js"
export * from "./ChatCallOverlay.vue?vue&type=script&lang=js"
import style0 from "./ChatCallOverlay.vue?vue&type=style&index=0&id=368e510f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports